/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetProductsBySubcategoryInput = {
  subcategoryId: string;
};

export type SearchUnitsByEanInput = {
  ean: string;
};

export type SearchUnitsByTextInput = {
  query: string;
};

export type GetProductsBySubcategoryV2WithPriceQueryVariables = Exact<{
  input: Types.GetProductsBySubcategoryInput;
}>;

export type GetProductsBySubcategoryV2WithPriceQuery = {
  getProductsBySubcategoryV2: {
    products: Array<{
      sku: string;
      name: string;
      imageUrl: string | null;
      price: number | null;
      bio: boolean | null;
      productClassification: Array<string> | null;
      countryOfOrigin: { code: string | null };
      units: Array<{ ean: string | null; id: string; type: string }>;
    }>;
  };
};

export type SearchUnitsByEanWithPriceQueryVariables = Exact<{
  searchUnitsByEanInput: Types.SearchUnitsByEanInput;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type SearchUnitsByEanWithPriceQuery = {
  searchUnitsByEan: {
    units: Array<{
      ean: string | null;
      id: string;
      type: string;
      product: {
        sku: string;
        name: string;
        imageUrl: string | null;
        price: number | null;
        productClassification: Array<string> | null;
        countryOfOrigin: { code: string | null };
      };
    }>;
  };
};

export type SearchUnitsByTextWithPriceQueryVariables = Exact<{
  searchUnitsByTextInput: Types.SearchUnitsByTextInput;
}>;

export type SearchUnitsByTextWithPriceQuery = {
  searchUnitsByText: {
    units: Array<{
      ean: string | null;
      id: string;
      type: string;
      product: {
        sku: string;
        name: string;
        imageUrl: string | null;
        price: number | null;
        productClassification: Array<string> | null;
        countryOfOrigin: { code: string | null };
      };
    }>;
  };
};

export const GetProductsBySubcategoryV2WithPriceDocument = gql`
  query getProductsBySubcategoryV2WithPrice($input: GetProductsBySubcategoryInput!) {
    getProductsBySubcategoryV2(input: $input) {
      products {
        sku
        name
        imageUrl
        price
        bio
        productClassification
        countryOfOrigin {
          code
        }
        units {
          ean
          id
          type
        }
      }
    }
  }
`;

/**
 * __useGetProductsBySubcategoryV2WithPriceQuery__
 *
 * To run a query within a React component, call `useGetProductsBySubcategoryV2WithPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsBySubcategoryV2WithPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsBySubcategoryV2WithPriceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductsBySubcategoryV2WithPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProductsBySubcategoryV2WithPriceQuery,
    GetProductsBySubcategoryV2WithPriceQueryVariables
  > &
    (
      | { variables: GetProductsBySubcategoryV2WithPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProductsBySubcategoryV2WithPriceQuery,
    GetProductsBySubcategoryV2WithPriceQueryVariables
  >(GetProductsBySubcategoryV2WithPriceDocument, options);
}
export function useGetProductsBySubcategoryV2WithPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductsBySubcategoryV2WithPriceQuery,
    GetProductsBySubcategoryV2WithPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProductsBySubcategoryV2WithPriceQuery,
    GetProductsBySubcategoryV2WithPriceQueryVariables
  >(GetProductsBySubcategoryV2WithPriceDocument, options);
}
// @ts-ignore
export function useGetProductsBySubcategoryV2WithPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductsBySubcategoryV2WithPriceQuery,
    GetProductsBySubcategoryV2WithPriceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetProductsBySubcategoryV2WithPriceQuery,
  GetProductsBySubcategoryV2WithPriceQueryVariables
>;
export function useGetProductsBySubcategoryV2WithPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProductsBySubcategoryV2WithPriceQuery,
        GetProductsBySubcategoryV2WithPriceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetProductsBySubcategoryV2WithPriceQuery | undefined,
  GetProductsBySubcategoryV2WithPriceQueryVariables
>;
export function useGetProductsBySubcategoryV2WithPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProductsBySubcategoryV2WithPriceQuery,
        GetProductsBySubcategoryV2WithPriceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProductsBySubcategoryV2WithPriceQuery,
    GetProductsBySubcategoryV2WithPriceQueryVariables
  >(GetProductsBySubcategoryV2WithPriceDocument, options);
}
export type GetProductsBySubcategoryV2WithPriceQueryHookResult = ReturnType<
  typeof useGetProductsBySubcategoryV2WithPriceQuery
>;
export type GetProductsBySubcategoryV2WithPriceLazyQueryHookResult = ReturnType<
  typeof useGetProductsBySubcategoryV2WithPriceLazyQuery
>;
export type GetProductsBySubcategoryV2WithPriceSuspenseQueryHookResult = ReturnType<
  typeof useGetProductsBySubcategoryV2WithPriceSuspenseQuery
>;
export type GetProductsBySubcategoryV2WithPriceQueryResult = Apollo.QueryResult<
  GetProductsBySubcategoryV2WithPriceQuery,
  GetProductsBySubcategoryV2WithPriceQueryVariables
>;
export const SearchUnitsByEanWithPriceDocument = gql`
  query searchUnitsByEanWithPrice(
    $searchUnitsByEanInput: SearchUnitsByEanInput!
    $isAlwaysInbound: Boolean
  ) {
    searchUnitsByEan(
      searchUnitsByEanInput: $searchUnitsByEanInput
      isAlwaysInbound: $isAlwaysInbound
    ) {
      units {
        ean
        id
        type
        product {
          sku
          name
          imageUrl
          price
          productClassification
          countryOfOrigin {
            code
          }
        }
      }
    }
  }
`;

/**
 * __useSearchUnitsByEanWithPriceQuery__
 *
 * To run a query within a React component, call `useSearchUnitsByEanWithPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnitsByEanWithPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnitsByEanWithPriceQuery({
 *   variables: {
 *      searchUnitsByEanInput: // value for 'searchUnitsByEanInput'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useSearchUnitsByEanWithPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchUnitsByEanWithPriceQuery,
    SearchUnitsByEanWithPriceQueryVariables
  > &
    ({ variables: SearchUnitsByEanWithPriceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUnitsByEanWithPriceQuery, SearchUnitsByEanWithPriceQueryVariables>(
    SearchUnitsByEanWithPriceDocument,
    options,
  );
}
export function useSearchUnitsByEanWithPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchUnitsByEanWithPriceQuery,
    SearchUnitsByEanWithPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchUnitsByEanWithPriceQuery,
    SearchUnitsByEanWithPriceQueryVariables
  >(SearchUnitsByEanWithPriceDocument, options);
}
// @ts-ignore
export function useSearchUnitsByEanWithPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchUnitsByEanWithPriceQuery,
    SearchUnitsByEanWithPriceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchUnitsByEanWithPriceQuery,
  SearchUnitsByEanWithPriceQueryVariables
>;
export function useSearchUnitsByEanWithPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchUnitsByEanWithPriceQuery,
        SearchUnitsByEanWithPriceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchUnitsByEanWithPriceQuery | undefined,
  SearchUnitsByEanWithPriceQueryVariables
>;
export function useSearchUnitsByEanWithPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchUnitsByEanWithPriceQuery,
        SearchUnitsByEanWithPriceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchUnitsByEanWithPriceQuery,
    SearchUnitsByEanWithPriceQueryVariables
  >(SearchUnitsByEanWithPriceDocument, options);
}
export type SearchUnitsByEanWithPriceQueryHookResult = ReturnType<
  typeof useSearchUnitsByEanWithPriceQuery
>;
export type SearchUnitsByEanWithPriceLazyQueryHookResult = ReturnType<
  typeof useSearchUnitsByEanWithPriceLazyQuery
>;
export type SearchUnitsByEanWithPriceSuspenseQueryHookResult = ReturnType<
  typeof useSearchUnitsByEanWithPriceSuspenseQuery
>;
export type SearchUnitsByEanWithPriceQueryResult = Apollo.QueryResult<
  SearchUnitsByEanWithPriceQuery,
  SearchUnitsByEanWithPriceQueryVariables
>;
export const SearchUnitsByTextWithPriceDocument = gql`
  query searchUnitsByTextWithPrice($searchUnitsByTextInput: SearchUnitsByTextInput!) {
    searchUnitsByText(searchUnitsByTextInput: $searchUnitsByTextInput) {
      units {
        ean
        id
        type
        product {
          sku
          name
          imageUrl
          price
          productClassification
          countryOfOrigin {
            code
          }
        }
      }
    }
  }
`;

/**
 * __useSearchUnitsByTextWithPriceQuery__
 *
 * To run a query within a React component, call `useSearchUnitsByTextWithPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnitsByTextWithPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnitsByTextWithPriceQuery({
 *   variables: {
 *      searchUnitsByTextInput: // value for 'searchUnitsByTextInput'
 *   },
 * });
 */
export function useSearchUnitsByTextWithPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchUnitsByTextWithPriceQuery,
    SearchUnitsByTextWithPriceQueryVariables
  > &
    ({ variables: SearchUnitsByTextWithPriceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUnitsByTextWithPriceQuery, SearchUnitsByTextWithPriceQueryVariables>(
    SearchUnitsByTextWithPriceDocument,
    options,
  );
}
export function useSearchUnitsByTextWithPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchUnitsByTextWithPriceQuery,
    SearchUnitsByTextWithPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchUnitsByTextWithPriceQuery,
    SearchUnitsByTextWithPriceQueryVariables
  >(SearchUnitsByTextWithPriceDocument, options);
}
// @ts-ignore
export function useSearchUnitsByTextWithPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchUnitsByTextWithPriceQuery,
    SearchUnitsByTextWithPriceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchUnitsByTextWithPriceQuery,
  SearchUnitsByTextWithPriceQueryVariables
>;
export function useSearchUnitsByTextWithPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchUnitsByTextWithPriceQuery,
        SearchUnitsByTextWithPriceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchUnitsByTextWithPriceQuery | undefined,
  SearchUnitsByTextWithPriceQueryVariables
>;
export function useSearchUnitsByTextWithPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchUnitsByTextWithPriceQuery,
        SearchUnitsByTextWithPriceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchUnitsByTextWithPriceQuery,
    SearchUnitsByTextWithPriceQueryVariables
  >(SearchUnitsByTextWithPriceDocument, options);
}
export type SearchUnitsByTextWithPriceQueryHookResult = ReturnType<
  typeof useSearchUnitsByTextWithPriceQuery
>;
export type SearchUnitsByTextWithPriceLazyQueryHookResult = ReturnType<
  typeof useSearchUnitsByTextWithPriceLazyQuery
>;
export type SearchUnitsByTextWithPriceSuspenseQueryHookResult = ReturnType<
  typeof useSearchUnitsByTextWithPriceSuspenseQuery
>;
export type SearchUnitsByTextWithPriceQueryResult = Apollo.QueryResult<
  SearchUnitsByTextWithPriceQuery,
  SearchUnitsByTextWithPriceQueryVariables
>;
